/**
 * @generated SignedSource<<7d47dafec3f3560d64fc18784e02d428>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FooterRenderer$data = {
  readonly totalIssueSearchResultCount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCountRenderer" | "IssueCreateFooter" | "PaginationControls">;
  readonly " $fragmentType": "FooterRenderer";
};
export type FooterRenderer$key = {
  readonly " $data"?: FooterRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FooterRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    }
  ],
  "kind": "Fragment",
  "name": "FooterRenderer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueCountRenderer"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueCreateFooter"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "pageSize",
          "variableName": "pageSize"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PaginationControls"
    },
    {
      "kind": "ScalarField",
      "name": "totalIssueSearchResultCount"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "3b4b5fcc961dfdfdc9948a5e19cf7228";

export default node;
